import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import "./AvatarDialog.css";

export default function AvatarDialog({ onClose, onClaim }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [claimed, setClaimed] = useState(false);

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);

      // Check if already claimed for this user
      if (currentUser) {
        const claimKey = `claimed_${currentUser.uid}`;
        const alreadyClaimed = localStorage.getItem(claimKey);
        setClaimed(!!alreadyClaimed);
      }
    });

    return () => unsubscribe();
  }, []);

  // Handle claim button click
  const handleClaim = () => {
    if (user) {
      const claimKey = `claimed_${user.uid}`;
      localStorage.setItem(claimKey, "true");
      setClaimed(true);
      onClaim?.(); // trigger parent action
      onClose?.(); // close dialog
    }
  };

  // 🧩 Conditions to not render:
  // - still loading auth
  // - no user (not logged in)
  // - already claimed
  if (loading || !user || claimed) {
    return null;
  }

  return (
    <div className="avatar-dialog-overlay">
      <div className="avatar-dialog">
        <button className="close-icon" onClick={onClose}>✖</button>

        <img
          src="https://cdn-icons-png.flaticon.com/512/4333/4333609.png"
          alt="avatar"
          className="avatar-img"
        />
        <h3>🎉 Welcome Bonus!</h3>
        <p>You haven’t claimed your <strong>5 free tokens</strong> yet.</p>

        <div className="dialog-actions">
          <button className="claim-btn" onClick={handleClaim}>Claim Now</button>
        </div>
      </div>
    </div>
  );
}
